import React from 'react';
import Button from '@atlaskit/button/standard-button';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import MoreIcon from '@atlaskit/icon/glyph/more';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages';

export type DropdownCellProps = {
	title: string;
	onClick: () => void;
};

export type DropdownMenuProps = {
	isLocked: boolean;
	dropdownCellItems: DropdownCellProps[];
	onDropdownMenuToggle?: () => void;
	tooltipDelay?: number;
};

export const DropdownCell = ({
	isLocked,
	dropdownCellItems,
	onDropdownMenuToggle,
	tooltipDelay,
}: DropdownMenuProps) => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip
			content={
				isLocked ? formatMessage(messages.isLockedTooltip) : formatMessage(messages.actionsTooltip)
			}
			position="left"
			delay={tooltipDelay}
		>
			<DropdownMenu
				testId="admin-pages-priority-schemes.ui.priority-schemes-table.dropdown-cell.dropdown-menu"
				onOpenChange={onDropdownMenuToggle}
				trigger={({ triggerRef, ...props }) => (
					<Button
						{...props}
						iconBefore={<MoreIcon label={formatMessage(messages.moreButtonIconLabel)} />}
						ref={triggerRef}
					/>
				)}
			>
				<DropdownItemGroup>
					{dropdownCellItems.map((e) => (
						<DropdownItem key={e.title} onClick={e.onClick}>
							{e.title}
						</DropdownItem>
					))}
				</DropdownItemGroup>
			</DropdownMenu>
		</Tooltip>
	);
};
